<template>
    <div>
        <el-dialog
            title="我的奖券"
            :visible.sync="MyCdKeyDialogVisible"
            :append-to-body="true"
            width="800px"
            :center="true"
            top="100px"
            :close-on-click-modal="false"
            :before-close="() => $emit('ExitMyCdKeyDialog')"
        >
            <el-tabs v-model="activeName" type="border-card" :stretch="true">
                <el-tab-pane label="抽奖信息" name="num">
                    <el-descriptions
                        direction="vertical"
                        :column="2"
                        :labelStyle="{'text-align':'center','background-color':'#FFFFFF','padding-bottom':'0px'}"
                        :contentStyle="{'text-align': 'center','background-color':'#FFFFFF','padding-bottom':'0px'}"
                        :colon="false"
                    >
                        <el-descriptions-item v-for="item in luck" :key="item.item">
                            <template slot="label">
                                <img v-if="item.item === '幸运值'" :src="$store.state.baseURL+'icon/xingyunzhi.png'" height="100px" class="luck_tubiao">
                                <img v-else-if="item.item === '幸运值pro'" :src="$store.state.baseURL+'icon/xingyunzhipro.png'" height="100px" class="luck_tubiao">
                                <img v-else-if="item.item === '残缺密信'" :src="$store.state.baseURL+'icon/canquemixin.png'" height="100px" class="luck_tubiao">
                                <img v-else-if="item.item === '剩余抽奖次数'" :src="$store.state.baseURL+'icon/choujiangcishu.png'" height="100px" class="luck_tubiao">
                            </template>
                            <div v-if="item.item === '幸运值'" class="luck_shuzi">{{item.item}}：<span style="color: #49d50c;">{{ item.nums }}</span></div>
                            <div v-else-if="item.item === '幸运值pro'" class="luck_shuzi">{{item.item}}：<span style="color: #d4247a;">{{ item.nums }}</span></div>
                            <div v-else-if="item.item === '残缺密信'" class="luck_shuzi">{{item.item}}：<span style="color: #ca9159;">{{ item.nums }}</span></div>
                            <div v-else-if="item.item === '剩余抽奖次数'" class="luck_shuzi">抽奖次数：<span style="color: #ef602e;">{{ item.nums }}</span></div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane label="奖券列表" name="cdk">
                    <el-table
                        :data="data"
                        style="width: 100%"
                        border
                        stripe
                        highlight-current-row
                        size="mini"
                        height="405px"
                    >
                        <el-table-column>
                            <template v-slot:header>
                                <div style="text-align: center;color: #2828FF;font-family: HarmonyOS_Sans_Black;font-size: 15px;">
                                    <span>未使用的奖券</span>
                                </div>
                            </template>
                            <el-table-column
                                align="center"
                                type="index"
                                min-width="20px">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="key"
                                label="奖券KEY"
                                min-width="200px"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.key }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="name"
                                label="绑定玩家"
                                min-width="180px"
                            >
                                <template slot-scope="scope">
                                    <span style="color: #CE0000;">{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <prize-draw-component
                :dialogVisible="PrizeDialogVisible"
                @RefreshBindKey="$emit('RefreshBindKey')"
                @closeDialog="PrizeDialogVisible = false"
            ></prize-draw-component>
            <prize10-draw-component
                :dialogVisible="Prize10DialogVisible"
                @RefreshBindKey="$emit('RefreshBindKey')"
                @closeDialog="Prize10DialogVisible = false"
                ref="Prize10Ref"
            ></prize10-draw-component>
            <common-prize-draw-component
                :CommonPrizeDialogVisible="CommonPrizeDialogVisible"
                @RefreshBindKey="$emit('RefreshBindKey')"
                @closeDialog="CommonPrizeDialogVisible = false"
            ></common-prize-draw-component>
            <chance-dialog-component
                :ChanceDialogVisible="ChanceDialogVisible"
                @ExitChanceDialog="ChanceDialogVisible = false"
            ></chance-dialog-component>
            <div slot="footer">
                <el-button type="primary" plain @click="ChanceDialogVisible = true">概率公示</el-button>
                <el-button type="success" plain @click="PrizeDialogVisible = true">单抽试水</el-button>
                <el-button type="warning" plain @click="Prize10Click">优雅十连</el-button>
                <el-button type="danger" plain @click="CommonPrizeDialogVisible = true">手动兑换</el-button>
                <el-button plain @click="$emit('ExitMyCdKeyDialog')">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PrizeDrawComponent from '@/components/index/PrizeDrawComponent'
import Prize10DrawComponent from '@/components/index/Prize10DrawComponent'
import CommonPrizeDrawComponent from '@/components/index/CommonPrizeDrawComponent'
import ChanceDialogComponent from '@/components/index/ChanceDialogComponent'

export default {
    name:'',
    data(){
        return {
            ChanceDialogVisible: false,
            PrizeDialogVisible:false,
            Prize10DialogVisible:false,
            CommonPrizeDialogVisible:false,
            activeName: 'num'
        }
    },
    computed:{},
    methods:{
        Prize10Click() {
            if(this.luck[3]['nums']*1 < 10)
            {
                this.$message.error('抽奖次数不足')
                return
            }
            this.Prize10DialogVisible = true
            this.$refs['Prize10Ref'].get_award()
        }
    },
    filters:{},
    props:{
        MyCdKeyDialogVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        data: {
            type: Array,
            default() {
                return []
            }
        },
        luck: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created(){},
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{
        ChanceDialogComponent,
        PrizeDrawComponent,
        Prize10DrawComponent,
        CommonPrizeDrawComponent
    },
    watch:{}
}
</script>

<style lang='less' scoped>
.luck_tubiao {
    margin-top: 29px;
}
.luck_shuzi  {
    margin-bottom: 28px;
    font-size: 25px;
    font-family: HarmonyOS_Sans_Black;
}
</style>